exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-36f7ddea] .el-card__body{height:100%}.picture-wrap[data-v-36f7ddea]{display:inline-block;width:200px}", ""]);

// exports
